import { useApiClient } from "@/composables/useApiClient";
import type { UserLimit } from "@/services/fobizzToolsApi";
import { useQuery, useQueryClient } from "@tanstack/vue-query";

export function useUserLimits() {
  const userLimits = computed(() => {
    if (data.value) {
      return data.value;
    }
    return [] as UserLimit[];
  });

  const queryClient = useQueryClient();

  const { userLimits: userLimitsService } = useApiClient();
  const { data } = useQuery(
    {
      queryKey: ["userLimits"],
      queryFn: () => userLimitsService.allLimits(),
    },
    queryClient
  );

  const refresh = () => {
    queryClient.invalidateQueries({ queryKey: ["userLimits"] });
  };

  return {
    userLimits,
    refresh,
  };
}
